import React, {
  useEffect, useLayoutEffect, useRef, useState,
} from 'react';
import { HashRouter as Router } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import {
  FehlerModal,
  handleSession,
  IfilialePartnerDatenschutz,
  LoadingIndicator,
  OEVFooter,
  Routing,
  TooltipModal,
  trEnv,
  VersionInfo,
  updateWindowHeightForIF,
  Siegel,
  handleLokalSpeichern,
  neutralizeBack,
  actions,
  SaveStateModal,
  appActions,
  HeadNavigation,
  isEmptyObj,
  ErrorToast, If,
} from 'ion-lib';
import { useDispatch, useSelector } from 'react-redux';
import i18next from 'i18next';
import { pages } from '../+config';
import * as tracking from '../tracking';
import pageComponents from './pageComponents';
import { setBeratersuche } from '../helper';
import holeVorbelegungenHausrat from '../actions/action';

const App = () => {
  const dispatch = useDispatch();
  const ref = useRef(null);
  const [showToast, setShowToast] = useState(false);
  const [showFootertext, setShowFootertext] = useState(false);
  const appDaten = useSelector((state) => state.appDaten);
  const daten = useSelector((state) => state.daten);

  if (appDaten.errorBoundary && process.env.NODE_ENV !== 'development') {
    throw Error(appDaten.errorBoundary);
  }

  const vorbelegungen = () => {
    dispatch(actions.updateByName('appDaten.pages', pages));
    dispatch(holeVorbelegungenHausrat(({ daten: newDaten }) => {
      handleSession(newDaten.sessionId, () => dispatch(actions.updateByName('appDaten.preset', '')));
      const appVersion = `${process.env.REACT_APP_IVVVERSION}-${import.meta.env.BUILD_TIME}`;
      handleLokalSpeichern({ dispatch, daten: newDaten, appVersion });
    }));
  };

  const handleToast = (status) => {
    if (!status) {
      dispatch(appActions.setErrorBoundary(''));
    }
    setShowToast(status);
  };

  // einmalig vorbelegung holen
  useEffect(() => {
    vorbelegungen();

    if (trEnv.sparkasse) {
      neutralizeBack();
    }

    if (!trEnv.sparkasse && trEnv.istVGH) {
      if (!appDaten.initTracking) {
        tracking.trackByName('appStart', window.location.href);
        dispatch(actions.updateByName('appDaten.initTracking', true));
      }

      const targetNode = document.getElementById('root');
      const observerOptions = {
        childList: true,
        attributes: false,
        subtree: true,
      };

      const observer = new MutationObserver(() => {
        tracking.addOnBlur(targetNode);
        tracking.addOnClick(targetNode);
      });
      observer.observe(targetNode, observerOptions);
    }
  }, []);

  // toast einblenden
  useEffect(() => {
    if (appDaten.errorBoundary) {
      handleToast(true);
    }
  }, [appDaten.errorBoundary]);

  useEffect(() => {
    setShowFootertext(window.location.href.endsWith('html#') || window.location.href.endsWith('html#/'));
  }, [window.location.href]);

  // höhe updaten für ifiliale
  useLayoutEffect(() => {
    updateWindowHeightForIF();
  }, []);

  if (isEmptyObj(daten) || !appDaten.pages.length) {
    return (
      <div className="bs-iso">
        <LoadingIndicator show />
        <ErrorToast show={showToast} message={appDaten.errorBoundary} onClose={() => { handleToast(false); }} />
      </div>
    );
  }

  return (
    <div className="bs-iso" ref={ref}>
      <Container>
        <Router
          hashType="noslash"
        >
          <HeadNavigation />
          <Routing
            pages={pages}
            components={pageComponents}
            onChange={(location) => {
              tracking.trackByName('urlChange', location.pathname);
            }}
            container={ref}
          />
        </Router>

        <Siegel />

        <IfilialePartnerDatenschutz />

        <OEVFooter beraterHref={setBeratersuche('beratersuche', daten.wagnis, daten.vertretersuche)} />
        <If predicate={!trEnv.sparkasse && showFootertext}>
          <div className="mt-5" dangerouslySetInnerHTML={{ __html: i18next.t('footertext') }} />
        </If>
        <VersionInfo date={import.meta.env.BUILD_TIME} />

        <TooltipModal
          container={ref}
        />

        <SaveStateModal />
        <FehlerModal />
        <ErrorToast show={showToast} message={appDaten.errorBoundary} onClose={() => { handleToast(false); }} />
      </Container>
      <LoadingIndicator show={!!appDaten.loading} />
    </div>
  );
};

export default App;
